import apiClient from '../../../services/apiClient';
import cacheService from '../../../services/cacheService';
import eventBus from '../../../services/globalEventBus';

export const linkChurchAccount = (orgId: string, churchAccountId: string, churchAccountName: string): Promise<void> =>
  new Promise<void>((resolve, reject) => {
    cacheService.removeAllInPath('/v2/user/associated-church-accounts');
    cacheService.removeAllInPath('/v2/user/organizations');
    cacheService.removeAllInPath('/v1/organizations');
    cacheService.remove('/v1/license-pairing-orgs');

    const subscriptions: Array<() => void> = [];
    const unsubscribeAll = () => subscriptions.forEach(unsubscribe => unsubscribe());

    subscriptions.push(
      eventBus.subscribe('ChurchAccountLinked', data => {
        if (data?.id !== orgId) return;

        unsubscribeAll();
        resolve();
      }),
      eventBus.subscribe('LinkChurchAccountFailed', error => {
        if (error?.id !== orgId) return;

        // If we receive a LinkInProgress code, we want to continue to wait
        // for the success event and not treat this as a true error.
        if (error?.code === 'LinkInProgress') return;

        unsubscribeAll();
        reject(error);
      })
    );

    const cmd = { id: churchAccountId, orgId, churchAccountName };
    apiClient.post('/v1/commands/AttemptLinkChurchAccount', cmd).catch(response => {
      reject(response);
      unsubscribeAll();
    });
  });
